import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { getDocuments } from "../../redux/actions/actionDocument";
import { getClientes } from "../../redux/actions/actionClient";
import InformesPresupuestosCard from "./informesPresupuestoCard";
import {
  SALDADO,
  NO_SALDADO,
  ALL_DOCUMENTS,
  SIETE_SEND,
  SIETE_OUT,  
} from "../../Constantes/constantesFiltros";
import { format, addDays } from "date-fns";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Swal from "sweetalert2";
import LoadingIcons from 'react-loading-icons'

export default function InformesPresupuestos(){

  const dispatch = useDispatch();
  
  const documents = useSelector(state => state.documents.allDocuments);
  const [docAux, setDocAux] = useState();
  const [checkSal, setCheckSal] = useState({ selectedOption: ALL_DOCUMENTS });   
  const [startDate] = useState(new Date());
  const [dateFind, setDateFind] = useState({
    desde: new Date(),
    hasta: new Date(),
  });

  useEffect(() => {    
    dispatch(getDocuments());
    dispatch(getClientes());   
  }, []);

  const handleCheck = (e) => {
    const { value } = e.target;
    console.log(value);

    setCheckSal({ selectedOption: e.target.value });
    switch (value) {
      case SALDADO:        
          if (docAux === undefined) {
            let auxDocuments = documents[0].filter((e) => e.state === true);
            setDocAux(auxDocuments);
          }
          if (docAux !== undefined) {
            let auxDocuments = documents[0].filter((e) => e.state === true);
            setDocAux(auxDocuments);
          }        
        break;
      case NO_SALDADO:
          if (docAux === undefined) {
            let auxDocuments = documents[0].filter((e) => e.state === false);
            setDocAux(auxDocuments);
          }
          if (docAux !== undefined) {
            let auxDocuments = documents[0].filter((e) => e.state === false);
            setDocAux(auxDocuments);
          }
        break;
      case ALL_DOCUMENTS:
          setDocAux(documents[0]);
        break;
      case SIETE_SEND:
        {
          let today = new Date();
          let dateSeven = addDays(today, 7);
          let dateMenosDosDias = addDays(today, -2);
          console.log(dateMenosDosDias);
          let send = documents[0].filter(
            (e) =>
              new Date(e.dateSend) >= dateMenosDosDias &&
              new Date(e.dateSend) <= dateSeven
          );
          setDocAux(send);
        }
        break;
      case SIETE_OUT:
        {
          let today = new Date();
          let dateSeven = addDays(today, 7);
          let dateMenosDosDias = addDays(today, -4);
          let send = documents[0].filter(
            (e) =>
              new Date(e.dateReception) >= dateMenosDosDias &&
              new Date(e.dateReception) <= dateSeven
          );
          setDocAux(send);
        }
        break;
        
        default:
          break;
        }
      };

      const handleChange = (e) => {
        const { value } = e.target;
        console.log(value);
        //setDocAux(value);
        filterDoc(value);      
      };

      const filterDoc = (doc) => {
        console.log(doc);
        if (docAux === undefined) {
          let result = documents[0].filter((e) => {
            if (
              e.client_id.nameCompany
                .toString()
                .toLowerCase()
                .includes(doc.toLowerCase()) ||
                e.numberDocument == doc
                ) {
              console.log(e)          
              return e;
            }
          });
          setDocAux(result);
        } else {
          let result = docAux.filter((e) => {
            if (
              e.client_id.nameCompany
              .toString()
              .toLowerCase()
              .includes(doc.toLowerCase()) ||
              e.numberDocument == doc
              ) {
                //console.log(e)
                return e;
              }
            });
            setDocAux(result);
          }
        };

        const handleLimpiar = () => {
          setDocAux(documents[0]);
        };
    
    
        const handleDateDesde = (date) => {
          console.log(date);
          setDateFind({
            ...dateFind,
            desde: date,
          });
        };

        const handleDateHasta = (date) => {
          setDateFind({
            ...dateFind,
          hasta: date,
        });
      };

      const handleDateFind = () => {
        console.log(dateFind.desde)
        console.log(dateFind.hasta)
        console.log(new Date(documents[0][0].dateSend))
        if(dateFind.desde > dateFind.hasta){
          Swal.fire(`La fecha "Desde" no puede ser mayor a "Hasta"`)
        } else { 
          let search = documents[0].filter( (e) => new Date(e.dateSend) >= dateFind.desde && new Date(e.dateReception) <= dateFind.hasta)
          setDocAux(search);
        }
      };

      const handleDateClean = () => {
        setDateFind({
          desde: new Date(),
          hasta: new Date()
        })
        setDocAux(documents[0])
      }
  

    return (
        <div className="container bg-gray-900">
      
      <div className="">
        <div className="text-[20pt] h-10 ml-2 mt-4 pb-8 underline text-orange-500">
            Informes - Presupuestos
        </div>     

        
        <div className="flex flex-row h-24 pl-2 pt-2 mt-4 bg-cyan-900">
          <div className="flex flex-col w-40 text-[12px] font-bold text-yellow-500">
            <label>A Siete Dias</label>
            <div>
              <div className="flex flex-row w-40">
                <div className="w-36">Envios</div>
                <input
                  className=""
                  type="radio"
                  name="envios"
                  checked={checkSal.selectedOption === SIETE_SEND}
                  value={SIETE_SEND}
                  onChange={handleCheck}
                />
              </div>
              <div className="flex flex-row w-40">
                <div className="w-36">Recepciones</div>
                <input
                  className=""
                  type="radio"
                  name="recepciones"
                  checked={checkSal.selectedOption === SIETE_OUT}
                  value={SIETE_OUT}
                  onChange={handleCheck}
                />
              </div>
            </div>
          </div>

          <div className="flex flex-col w-44 text-[12px] text-yellow-500 font-bold pl-2">
            <label>Estados</label>
            <div>
              <div className="flex flex-row w-40">
                <div className="w-36">Todos los Documentos</div>
                <input
                  className=""
                  type="radio"
                  name="saldos"
                  checked={checkSal.selectedOption === ALL_DOCUMENTS}
                  value={ALL_DOCUMENTS}
                  onChange={handleCheck}
                />
              </div>
              <div className="flex flex-row w-40">
                <div className="w-36">Saldados</div>
                <input
                  className=""
                  type="radio"
                  name="saldos"
                  checked={checkSal.selectedOption === SALDADO}
                  value={SALDADO}
                  onChange={handleCheck}
                />
              </div>
              <div className="flex flex-row w-40">
                <div className="w-36">No Saldados</div>
                <input
                  type="radio"
                  name="saldos"
                  checked={checkSal.selectedOption === NO_SALDADO}
                  value={NO_SALDADO}
                  onChange={handleCheck}
                />
              </div>
            </div>
          </div>
          <div className="flex flex-row text-[12px] w-56 font-bold text-yellow-500 pt-1 pl-5">
            <p className="mr-2">Buscar</p>
            <input
              className="border border-slate-700 rounded w-44 h-4 text-center bg-cyan-700 placeholder-yellow-400"
              type="text"
              placeholder="Nombre Cliente"
              onChange={handleChange}
              //value={docs}
            />
          </div>
          <div className="w-36 pl-2 ">
            <div className="flex">
              <label className="text-[12px] text-yellow-500 font-bold">
                Desde
              </label>
              <div className="w-12 text-[12px] pl-2">
                <DatePicker
                  className="w-20 pl-1 rounded bg-cyan-700 text-[12px] text-yellow-400 font-bold"
                  selected={startDate}
                  onChange={handleDateDesde}
                  value={
                    dateFind.desde ? format(dateFind.desde, "dd/MM/yyyy") : null
                  }
                />
              </div>
            </div>
            <div className="flex w-12 text-[12px] mt-1">
              <label className="text-[12px] text-yellow-500 font-bold">
                Hasta
              </label>
              <div className="w-12 text-[12px] pl-3">
                <DatePicker
                  className="w-20 pl-1 rounded bg-cyan-700 text-[12px] text-yellow-400 font-bold"
                  selected={startDate}
                  onChange={handleDateHasta}
                  value={
                    dateFind.hasta ? format(dateFind.hasta, "dd/MM/yyyy") : null
                  }
                />
              </div>
            </div>
            <div className="flex w-32">
            <button className="w-14 mt-2 text-[12px] text-yellow-500 font-bold bg-cyan-700 rounded border-2 border-cyan-500 hover:text-white" onClick={handleDateFind}>
              Buscar
            </button>
            <button className="w-14 ml-2 mt-2 text-[12px] text-yellow-500 font-bold bg-cyan-700 rounded border-2 border-cyan-500 hover:text-white" onClick={handleDateClean}>
              Limpiar
            </button>
            </div>
          </div>
        </div>

        <div className="flex justify-center text-orange-500">
          <div className="text-[14px] font-bold text-center w-12">
            Doc N°
          </div>
          <div className="text-[14px] font-bold text-left pl-2 w-72">
            Cliente
          </div>
          <div className="text-[14px] font-bold text-left pl-2 w-80">
            Domicilio Evento
          </div>
          <div className="text-[14px] font-bold text-center w-20">
            Fecha de Salida
          </div>
          <div className="text-[14px] font-bold text-center w-20">
            Fecha de Entrada
          </div>
          <div className="text-[14px] font-bold text-center w-20">
            Total
          </div>                   
        </div>
        <div className="container max-h-screen overflow-y-auto">
        {documents.length === 0 ? <div className="flex h-[400px] items-center justify-center"><LoadingIcons.Bars /></div> : 
        docAux 
          ? docAux.map((e) => {
              return (
                <div key={e._id}>
                  <InformesPresupuestosCard
                    key={e._id}
                    id={e._id}
                    addressEvent={e.addressEvent}
                    name_client={e.client_id.nameCompany}
                    dateReception={e.dateReception}
                    dateSend={e.dateSend}
                    numberDocument={e.numberDocument}
                    totalCoeficiente={e.totalCoeficiente}
                    //approved={e.approved}                    
                  />
                </div>
              );
            })
          :

           documents[0] &&
            documents[0].map((e) => {
              return (
                <div key={e._id}>
                  <InformesPresupuestosCard
                    key={e._id}
                    id={e._id}
                    addressEvent={e.addressEvent}
                    name_client={e.client_id.nameCompany}
                    dateReception={e.dateReception}
                    dateSend={e.dateSend}
                    numberDocument={e.numberDocument}
                    totalCoeficiente={e.totalCoeficiente}
                    //approved={e.approved}                    
                  />
                </div>
              );
            })
            }
            </div>
      </div>

    </div>
    )
}